// extracted by mini-css-extract-plugin
export default {"danger":"ConfirmationModal_danger__N5lhK"};